exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._41_oV{background-color:#fff;margin-top:20px;margin-bottom:20px;width:100%;padding-top:5px}._1TfMC,._41_oV{position:relative}._1TfMC{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap}._3jxTT{width:300px}._2upSX{width:calc(100% - 330px)}._2Y3FY{text-decoration:none}._2Y3FY:hover{text-decoration:underline}._1HQlq{color:red;font-size:13.5px;font-weight:400;padding-bottom:10px}", ""]);

// exports
exports.locals = {
	"root": "_41_oV",
	"flexRow": "_1TfMC flexRow",
	"left": "_3jxTT",
	"right": "_2upSX",
	"infoLink": "_2Y3FY",
	"warningBlock": "_1HQlq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/spareparts/components/SparepartItem/SparepartItem.css
// module id = 3127
// module chunks = 36